export default __webpack_public_path__ + "static/media/fammefun.f797b374.png";